<template>
  <BButton
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    :disabled="disabled"
    class="my-button"
    variant="outline-secondary"
    @click="$emit('click')"
  >
    <FontAwesomeIcon icon="arrow-left" />
  </BButton>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'FilesBackButton',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    FontAwesomeIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.my-button {
  padding: 0.5rem 0.9rem;
}
</style>
